<div [class]="logoClass" [style]="backgroundImageStyles">
  <div class="icon-wrapper"><span class="icon"></span></div>
</div>
